import apiClient from './client'
import type { AuthResponse, AuthUser } from '../types'

export const authApi = {
  /** Exchange a Google ID token for an internal JWT. */
  async googleSignIn(idToken: string): Promise<AuthResponse> {
    const res = await apiClient.post<AuthResponse>('/api/auth/google', { idToken })
    return res.data
  },

  /** Fetch current user info using the stored Bearer token. */
  async me(): Promise<AuthUser> {
    const res = await apiClient.get<{ data: AuthUser }>('/api/auth/me')
    return res.data.data
  },
}
